var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMiniCulture02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 253,
    viewBox: "0 0 259 253",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.71875,
    y: 0.710938,
    width: 258,
    height: 252,
    fill: "#D38D8D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_500_12931",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 253
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.71875,
    y: 0.710938,
    width: 258,
    height: 252,
    fill: "#5292A7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_500_12931)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 129.719,
    y: 181.391,
    width: 113.127,
    height: 26.4786,
    fill: "#112C29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.719 181.395H242.846L236.417 166.387H136.148L129.719 181.395Z",
    fill: "#7AA6A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.883 59.8945H200.679V74.395H171.883V59.8945Z",
    fill: "#359085"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.883 158.49H200.679V172.991H171.883V158.49Z",
    fill: "#359085"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 186.281,
    cy: 172.992,
    rx: 14.3981,
    ry: 3.78333,
    fill: "#359085"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.679 74.2946C200.679 66.3427 194.233 59.8965 186.281 59.8965V59.8965C178.329 59.8965 171.883 66.3428 171.883 74.2946V77.5541C171.883 84.6625 167.024 90.6818 160.89 94.2753C148.103 101.768 139.646 114.755 139.646 129.522C139.646 152.726 160.526 171.537 186.282 171.537C212.039 171.537 232.918 152.726 232.918 129.522C232.918 114.755 224.461 101.766 211.673 94.2742C205.539 90.6808 200.679 84.6614 200.679 77.5526V74.2946Z",
    fill: "#359085"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 186.281,
    cy: 59.8947,
    rx: 14.3981,
    ry: 3.78333,
    fill: "#44ADA0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 186.283,
    cy: 59.8926,
    rx: 12.3514,
    ry: 2.67583,
    fill: "#334846"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.719,
    y: 62.3379,
    width: 113.127,
    height: 119.052,
    fill: "#A4D6D1",
    fillOpacity: 0.34
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.519 181.39L142.092 62.3379H162.193L188.558 181.39H169.519Z",
    fill: "#D0F1ED",
    fillOpacity: 0.14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.751 181.39L165.324 62.3379H169.996L196.361 181.39H192.751Z",
    fill: "#D0F1ED",
    fillOpacity: 0.14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.719 62.3397H242.846L235.131 50.7891H137.434L129.719 62.3397Z",
    fill: "#A4D6D1",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.387 242.711V222.914H190.152C194.65 222.914 197.234 225.689 197.234 229.586C197.234 233.537 194.609 236.258 190.043 236.258H186.488V242.711H182.387ZM186.488 232.949H189.387C191.82 232.949 193.01 231.582 192.996 229.586C193.01 227.617 191.82 226.291 189.387 226.277H186.488V232.949ZM201.199 242.957C199.914 242.957 198.875 241.932 198.902 240.66C198.875 239.402 199.914 238.377 201.199 238.391C202.416 238.377 203.469 239.402 203.469 240.66C203.469 241.932 202.416 242.957 201.199 242.957ZM206.805 242.711V222.914H214.57C219.068 222.914 221.652 225.689 221.652 229.586C221.652 233.537 219.027 236.258 214.461 236.258H210.906V242.711H206.805ZM210.906 232.949H213.805C216.238 232.949 217.428 231.582 217.414 229.586C217.428 227.617 216.238 226.291 213.805 226.277H210.906V232.949ZM228.215 222.914V242.711H224.168V222.914H228.215ZM238.086 243.012C233.533 242.998 230.744 240.059 230.758 235.355C230.744 230.775 233.574 227.672 237.922 227.672C241.818 227.672 244.895 230.133 244.895 235.191V236.34H234.75C234.75 238.582 236.076 239.963 238.168 239.977C239.549 239.963 240.533 239.361 240.93 238.473H244.785C244.211 241.221 241.75 242.998 238.086 243.012ZM234.75 233.797H241.066C241.053 231.992 239.809 230.693 238.004 230.707C236.145 230.693 234.832 232.088 234.75 233.797Z",
    fill: "black"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniCulture02);
export default __webpack_public_path__ + "static/media/mini_culture_02.457ed7ce65b65e29ec9726f598154125.svg";
export { ForwardRef as ReactComponent };